import { render, staticRenderFns } from "./BrokerCustomersWalletsEdit.vue?vue&type=template&id=6d0d32e0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./BrokerCustomersWalletsEdit.vue?vue&type=script&lang=js&"
export * from "./BrokerCustomersWalletsEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrokerCustomersWalletsEdit.vue?vue&type=style&index=0&id=6d0d32e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d32e0",
  null
  
)

export default component.exports